import { Select as SelectBase, Clear, Toggle } from './Select';
import { Tags } from './Tags';
import { Simple, Single, Multi } from './Simple';
export { SelectContext } from './Select';
export const Select = Object.assign(SelectBase, {
    Clear,
    Toggle,
    Tags,
    Simple,
    Single,
    Multi,
});
